import React, {Fragment, Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Loading, NotFoundError, Pagination, NewsCard} from 'cw-styleguide-react';
import config from "../../config";
import i18n from "../../i18n";
import qs from "qs";
import axios from "axios";
import {GelContentContainer, GelContentRow, StyleguideContext, withRouter} from "cw-styleguide-react";
import {GelContentColumn} from "cw-styleguide-react";
import {FeaturedArticle} from "cw-styleguide-react";
import Helmet from 'react-helmet';

class NewsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      news: null,
      settings: null
    };
  }

  getNews() {
    const parameters = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});

    axios.get(config.endpoints.news[i18n.language], {
      params: {
        page: parameters.page || 1,
        domain: config.domain,
        time: Date.now()
      }
    })
    .then(response => {
      this.setState({
        news: response.data
      });
    })
    .catch(error => {
      this.setState({
        error: new NotFoundError('Could not fetch the news API')
      });
    });
  }

  getNewsSettings() {
    axios.get(config.endpoints.newsSettings[i18n.language], {
      params: {
        time: Date.now()
      }
    })
      .then(response => {
        this.setState({
          settings: response.data
        });
      })
      .catch(error => {
        this.setState({
          error: new NotFoundError('Could not fetch the news settings API')
        });
      });
  }

  componentDidMount() {
    this.getNews();
    this.getNewsSettings();
    this.context.setLanguageUrl('');
  }

  componentDidUpdate(prevProps) {
    const currentParameters = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
    const previousParameters = qs.parse(prevProps.location.search, {ignoreQueryPrefix: true});

    if (currentParameters.page !== previousParameters.page) {
      this.getNews();
    }
  }

  render() {
    if (!this.state.news || !this.state.settings) {
      return <Loading/>;
    }

    const totalResults = this.state.news.featured ? this.state.news.pagination.total - 1 : this.state.news.pagination.total;

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('local:news')}</title>
          <meta name={'description'} content={this.props.t('local:metaDescription')}/>
        </Helmet>
        <GelContentContainer>
          <GelContentRow>
            <GelContentColumn md={12}>
              <h1>{this.props.t('local:news')}</h1>
            </GelContentColumn>
          </GelContentRow>
          {this.state.settings.introduction &&
          <GelContentRow>
            <GelContentColumn md={12}>
              <div dangerouslySetInnerHTML={{__html: this.state.settings.introduction}}/>
            </GelContentColumn>
          </GelContentRow>
          }
        </GelContentContainer>
        {this.state.news && this.state.news.featured &&
        <div className={'gel-xs-mb-40 gel-sm-mb-40 gel-md-mb-50 gel-lg-mb-50 gel-xl-mb-50'}>
          <FeaturedArticle
            title={this.state.news.featured.title}
            subtitle={this.props.t('local:featured')}
            date={!this.state.news.featured.hideDate ? this.state.news.featured.published.long : null}
            to={this.state.news.featured.localised ? this.state.news.featured.slug : this.state.news.featured.path}
            image={{
              source: this.state.news.featured.image,
              alternative: this.state.news.featured.title
            }}
          />
        </div>
        }
        <GelContentContainer>
          {this.state.settings.announcements &&
          <GelContentRow>
            <GelContentColumn md={12}>
              <div dangerouslySetInnerHTML={{__html: this.state.settings.announcements}}/>
            </GelContentColumn>
          </GelContentRow>
          }
          <GelContentRow>
            {this.state.news && this.state.news.results && this.state.news.results.map((item, index) => {
              return (
                <NewsCard
                  key={index}
                  link={{to: item.localised ? item.slug : item.path}}
                  title={item.title}
                  meta={!item.hideDate ? <time dateTime="00Z">{item.published.long}</time> : null}
                  source={item.image}
                  alt={item.title}
                >
                  <div dangerouslySetInnerHTML={{__html: item.description}}></div>
                </NewsCard>
              )
            })}
          </GelContentRow>
          {totalResults > this.state.news.pagination.limit &&
          <GelContentRow>
            <GelContentColumn md={12}>
              <Pagination total={totalResults} limit={this.state.news.pagination.limit}/>
            </GelContentColumn>
          </GelContentRow>
          }
        </GelContentContainer>
      </Fragment>
    )
  }
}

NewsList.contextType = StyleguideContext;
export default withTranslation('remote')(withRouter(NewsList))